import { Box, TextField, Typography } from "@material-ui/core";
import React, { useRef } from "react";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
  amountTickets: number;
  percentForAddingDiscounts: number;
  handleDeleteDiscount: () => void;
  handleChangeDiscountProps: (e: any) => void;
  countError?: boolean;
  percentError?: boolean;
  sortDiscountArrayOnBlur:()=>void
}

export const DiscountRow = ({
    amountTickets,
percentForAddingDiscounts,
  handleDeleteDiscount,
  handleChangeDiscountProps,
  countError,
  percentError,
  sortDiscountArrayOnBlur
}: Props) => {
  return (
    <Box display="flex" alignItems="center" marginBottom={1}>
      <Box className="creditPropfieldWrapper">
        <Box width={90} marginRight={1.5}>
          <TextField
            label=""
            size="small"
            variant="outlined"
            type="number"
            name="amountTickets"
            InputProps={{
              inputProps: {
                min: 1,
              },
              onBlur:sortDiscountArrayOnBlur
            }}
            error={countError}
            onChange={handleChangeDiscountProps}
            value={amountTickets||""}
          />
        </Box>
        <Box marginRight=".4rem"><Typography variant="subtitle1">ticket</Typography></Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        className="creditPropfieldWrapper"
      >
        <Box marginRight=".4rem"><Typography>discount is</Typography></Box>
        <Box width={90} marginRight={2}>
          <TextField
            label="%"
            size="small"
            variant="outlined"
            name="percent"
            type="number"
            InputProps={{
              inputProps: {
                min: 0,
                max:99
              },
            }}
            error={percentError}
            onChange={handleChangeDiscountProps}
            value={percentForAddingDiscounts}
          />
        </Box>
        <Box marginLeft={1} paddingTop={0.5}>
          <CloseIcon className="remove-discount" onClick={handleDeleteDiscount} />
        </Box>
      </Box>
    </Box>
  );
};
